module.exports = __webpack_public_path__ + "static/media/hingeHandleMainImg.d23df4aa.png";